import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  makeStyles,
  SvgIcon,
  ThemeProvider
} from '@material-ui/core';
import { AlignJustify as AlignJustifyIcon } from 'react-feather';
import { THEMES } from 'src/constantsMessage';
import Account from './Account';
import Logout from './Logout';
import { useSelector } from 'react-redux';
import useSettings from 'src/hooks/useSettings';
import { createTheme } from 'src/theme';
import getProductType from 'src/components/ProductType';

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    ...(theme.name === THEMES.LIGHT
      ? {
          boxShadow: 'none',
          backgroundColor: theme.palette.primary.main
        }
      : {}),
    ...(theme.name === THEMES.ONE_DARK
      ? {
          backgroundColor: theme.palette.background.default
        }
      : {})
  },
  toolbar: {
    minHeight: 64
  },
  name: {
    marginLeft: theme.spacing(1)
  },
  menuButton: {
    marginRight: theme.spacing(1)
  },
  menuOpen: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)'
  }
}));

function TopBar({ className, onMobileNavOpen, isMobileNavOpen, ...rest }) {
  const classes = useStyles();
  const account = useSelector(state => state.account);
  const { settings } = useSettings();

  const productType = getProductType();

  const handleOpen = () => {
    onMobileNavOpen();
  };
  return (
    <ThemeProvider theme={createTheme(settings)}>
      <AppBar className={clsx(classes.root, className)} {...rest}>
        <Toolbar className={classes.toolbar}>
          {account.user && (
            <IconButton
              className={clsx(
                classes.menuButton,
                isMobileNavOpen ? classes.menuOpen : ''
              )}
              color="inherit"
              onClick={() => handleOpen()}
            >
              <SvgIcon>
                <AlignJustifyIcon />
              </SvgIcon>
            </IconButton>
          )}
          <RouterLink to="/">
            <img
              alt="Logo"
              sizes="small"
              src={
                productType === 'Signzy'
                  ? '/static/signzyWhiteLogo.png'
                  : '/static/whiteHorizontallogo.png'
              }
            />
          </RouterLink>
          <Box ml={2} flexGrow={1} />
          {/* <Settings /> */}
          {account.user && <Logout />}
          <Box ml={2}>
            <Account />
          </Box>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

export default TopBar;
